// Mirror of the catalogue in packages/shared/src/profile.ts. The web workspace
// deliberately does not depend on @score-creator/shared — that is what keeps a
// second Zod runtime out of the browser bundle — so the plan split is repeated
// here. The API is the authority: it gates the payload before it ships, and
// these lists only decide what the editor offers and what the icons render.

export const NETWORK_KEYS = ["INSTAGRAM", "YOUTUBE", "TIKTOK", "TWITCH", "X", "LINKEDIN", "WEBSITE"] as const;
export type NetworkKey = (typeof NETWORK_KEYS)[number];

export const NETWORK_FIELD_ORDER = [
  "instagramUrl",
  "youtubeUrl",
  "tiktokUrl",
  "twitchUrl",
  "xUrl",
  "linkedinUrl",
  "websiteUrl",
] as const;
export type NetworkField = (typeof NETWORK_FIELD_ORDER)[number];

export const NETWORK_BY_FIELD: Record<NetworkField, NetworkKey> = {
  instagramUrl: "INSTAGRAM",
  youtubeUrl: "YOUTUBE",
  tiktokUrl: "TIKTOK",
  twitchUrl: "TWITCH",
  xUrl: "X",
  linkedinUrl: "LINKEDIN",
  websiteUrl: "WEBSITE",
};

export const NETWORK_LABELS: Record<NetworkKey, string> = {
  INSTAGRAM: "Instagram",
  YOUTUBE: "YouTube",
  TIKTOK: "TikTok",
  TWITCH: "Twitch",
  X: "X",
  LINKEDIN: "LinkedIn",
  WEBSITE: "Site",
};

export const NETWORK_PLACEHOLDERS: Record<NetworkField, string> = {
  instagramUrl: "https://instagram.com/usuario",
  youtubeUrl: "https://youtube.com/@canal",
  tiktokUrl: "https://tiktok.com/@usuario",
  twitchUrl: "https://twitch.tv/canal",
  xUrl: "https://x.com/usuario",
  linkedinUrl: "https://linkedin.com/in/usuario",
  websiteUrl: "https://seusite.com.br",
};

export const FREE_NETWORK_FIELDS: readonly NetworkField[] = ["instagramUrl", "websiteUrl"];
export const PREMIUM_NETWORK_FIELDS: readonly NetworkField[] = ["youtubeUrl", "tiktokUrl", "twitchUrl", "xUrl", "linkedinUrl"];

export const isPremiumNetwork = (field: NetworkField) => PREMIUM_NETWORK_FIELDS.includes(field);
export const networkFieldsFor = (premium: boolean) => premium ? NETWORK_FIELD_ORDER : FREE_NETWORK_FIELDS;
